import { useState } from "react";

import { Popup as UrbicaPopup, MapContext } from "@urbica/react-map-gl";
import styled from "styled-components";
import useThrottle from "../../../hooks/useThrottle";

const StyledPopup = styled(UrbicaPopup)`
    &.mapboxgl-popup {
        opacity: 0.9;
        /* transition: transform ease;
        transition-duration: 200ms; */
    }
`;
 
const Popup = ({ children, className, onClose, ...rest }) => {
    const [isMouseMoveEventSet, set_isMouseMoveEventSet] = useState(false);
    const [cursorPosition, set_cursorPosition] = useState(null);

    const onMousemove = useThrottle((e) => {
        set_cursorPosition({ latitude: e.lngLat.lat, longitude: e.lngLat.lng });
        return false;
    }, 100);

    return (
        <>
            <MapContext.Consumer>
                {(map) => {
                    if (isMouseMoveEventSet) return;
                    set_isMouseMoveEventSet(true);
                    map.on("mousemove", onMousemove);
                    return;
                }}
            </MapContext.Consumer>
            {cursorPosition && (
                <StyledPopup
                
                    {...cursorPosition}
                    {...rest}
                >
                    {children}
                </StyledPopup>
            )}
        </>
    );
};

export default Popup;
